'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGeosuggest = require('react-geosuggest');

var _reactGeosuggest2 = _interopRequireDefault(_reactGeosuggest);

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GooglePlaces = function (_Component) {
  _inherits(GooglePlaces, _Component);

  function GooglePlaces() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GooglePlaces);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GooglePlaces.__proto__ || Object.getPrototypeOf(GooglePlaces)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function (data) {
      if (!data.gmaps) {
        return;
      }

      var formattedData = {};
      var streetNumber = '';
      var route = '';
      data.gmaps.address_components.forEach(function (addressPart) {
        if (addressPart.types.indexOf('street_number') !== -1) {
          streetNumber = addressPart.long_name;
        }
        if (addressPart.types.indexOf('route') !== -1) {
          route = addressPart.long_name;
        }
        if (addressPart.types.indexOf('locality') !== -1) {
          formattedData.city = addressPart.long_name;
        }
        if (addressPart.types.indexOf('administrative_area_level_1') !== -1) {
          formattedData.state = addressPart.short_name;
        }
        if (addressPart.types.indexOf('postal_code') !== -1) {
          formattedData.zip = addressPart.long_name;
        }
      });
      formattedData.address = streetNumber + ' ' + route;
      formattedData.latitude = data.location.lat;
      formattedData.longitude = data.location.lng;
      formattedData.data = data;

      _this.props.onSelect(formattedData);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GooglePlaces, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var passThruProps = (0, _lodash2.default)(this.props, ['onSelect']);
      return _react2.default.createElement(_reactGeosuggest2.default, _extends({
        ref: function ref(input) {
          _this2.geosuggestInputRef = input;
        },
        onSuggestSelect: this.onSelect
      }, passThruProps));
    }
  }]);

  return GooglePlaces;
}(_react.Component);

GooglePlaces.propTypes = {
  onSelect: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string
};
GooglePlaces.defaultProps = {
  placeholder: 'Start Typing'
};
exports.default = GooglePlaces;


//////////////////
// WEBPACK FOOTER
// ./~/@synapsestudios/google-places-field/lib/GooglePlaces.js
// module id = 739
// module chunks = 0